import { Message } from 'element-ui';
import { dispatchPrint, updatePrintCount } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
// 当前组件上下文
let componentContext = null;
/**
 * @description 判断待缓存数据是否为有效值
 */
export const isEmpty = (value) => {
    return value === null || value === undefined || value === '' || ['[]', '{}'].includes(JSON.stringify(value));
};

/**
 * @description 从本地存储读取数据
 */
export const getLocalStorage = (key) => {
    if (!key) return;
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
};

/**
 * @description 写入数据到本地存储
 * @param {String} key 键名
 * @param {String|Object} value 键值
 */
export const setLocalStorage = (key, value) => {
    if (!key || isEmpty(value)) return;
    localStorage.setItem(key, JSON.stringify(value));
};

export function searchFieldSeperated (value) {
    return (value || '')
        .replace('，', ',')
        .replace(/\s+/g, ',')
        .split(/[,，]/)
        .map(no => no.trim())
        .filter(no => no);
}

/**
 * @description 处理打印逻辑
 * @param {Object} ctx 当前组件上下文
 * @param {Object} params 打印参数
 */
export const handleDispatchPrint = (ctx, params, close = false) => {
    componentContext = ctx; // 保存当前组件上下文
    componentContext.btnLoading = true;
    dispatchPrint(params)
        .then(res => {
            if (res && +res.code === 0) {
                if (res.data && res.data.length) {
                    handleUpdatePrintCount(params, res.data);
                    close && componentContext.beforeClose();
                };
            }
        })
        .finally(() => {
            componentContext.btnLoading = false;
        });
};

/**
 * @description 更新打印次数
 * @param {Object} params 更新打印接口参数
 * @param {String} url 打印的链接
 */
export const handleUpdatePrintCount = (params, data) => {
    return updatePrintCount(params).then(res => {
        if (res && +res.code === 0) {
            data.forEach(item => {
                item.url && window.open(item.url);
            });
        };
    });
};

/**
 * @description 打印校验
 * @param {Array} data 打印模板数据
 */
export const checkedDataValidated = data => {
    const checkedData = data.filter(v => v.checkedTemplate && v.checkedTemplate.length);
    if (!checkedData.length) {
        Message.warning('至少选择一个打印单');
        return false;
    }
    return true;
};
